/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import FlipProfilePhoto from '../../components/FlipProfilePhoto';
import Count from './Count';
import { OrgChartUser } from '../../types';

interface ParentUser extends OrgChartUser {
  id: string;
  reports: string[];
  manager: string | undefined;
}

interface ParentProps {
  user: ParentUser;
  onClick: (id: string) => void;
}

export default function Parent({ user, onClick }: ParentProps) {
  const handleClick = () => {
    onClick(user.id);
  };

  return (
    <div className="orgchart-parent">
      <div className="orgchart-card">
        <div className="orgchart-card-info-count" onClick={handleClick}>
          <div className="orgchart-card-info">
            <div className="orgchart-card-info-photo">
              <FlipProfilePhoto
                firstName={user.firstName}
                lastName={user.lastName}
                id={user.id}
              />
            </div>
            <div className="orgchart-card-info-profile">
              <h1>{`${user.firstName} ${user.lastName}`}</h1>
              <h2>{user.title}</h2>
            </div>
          </div>
          <Count total={user.reports.length} />
        </div>
      </div>
    </div>
  );
}
